module.exports = __webpack_public_path__ + "img/index3_2.d1bd222.jpg";